import { render, staticRenderFns } from "./proTemplate.vue?vue&type=template&id=b8ea3d9e&scoped=true"
import script from "./proTemplate.vue?vue&type=script&lang=js"
export * from "./proTemplate.vue?vue&type=script&lang=js"
import style0 from "./proTemplate.vue?vue&type=style&index=0&id=b8ea3d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ea3d9e",
  null
  
)

export default component.exports